const confirmationCodeEN = {
	title: "Confirm Account",
	subtitle: "Enter the code sent to your email and your account is ready to go.",
	hint: "Can’t find it? Check your spam folder — it arrives within a minute.",
	email: "Email",
	code: "Confirmation Code",
	button: "Confirm",
	loading: "Confirming...",
	resendCode: "Resend Code",
	sendingCode: "Sending...",
	backToLogin: "Back to Sign In",
	invalidCode: "That code isn't valid or has expired. Check your email and try again.",
};
export default confirmationCodeEN;
